export default {"src":"/_next/static/media/cotribute-logo.70e9c5e5.svg","height":44,"width":300,"blurWidth":0,"blurHeight":0};